import React from 'react';
import { FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';
import Link from '../../Link/Link';
import messages from '../../../locale/jsonMessages';

import Loader from '../../Loader/Loader';
import { validate } from './validate';
import submit from './submit'
import { GoBackArrow } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import cx from 'classnames';
import bt from '../../commonStyle.css';



function CancellationInfoForm({ handleSubmit }) {

  const isSelectedLanguage = useSelector(state => formValueSelector('CancellationInfoForm')(state, 'dynamicCancellationInfo'))
  const { formatMessage } = useIntl()

  return (
    <>
      <div className={cx(bt.displayFlex, bt.justifyContentSpaceBetween, bt.gap8, bt.space4, bt.flexWrap, bt.alignCenter, bt.spaceBottom4)}>
        <h1 className={cx('siteAdminHeading', bt.spaceBottom0)}>{formatMessage(messages.updateCancellationInfo)}</h1>
        <Link to={"/siteadmin/cancellation-policies"} className='goBackLink'>
          <GoBackArrow />
          <FormattedMessage  {...messages.goBack} />
        </Link>
      </div>
      <form onSubmit={handleSubmit(submit)}>
        <FieldArray
          name='dynamicCancellationInfo'
          component={FieldArrayComponent}
          selectedLanguage={isSelectedLanguage}
          isCancellationInfo
          descListClass='twoColumnGrid'
        />
        <div className={cx('singleBtnFlexEnd', bt.spaceTop4)}>
          <Loader
            type='button'
            buttonType='submit'
            label={formatMessage(messages.update)}
            className={bt.btnPrimary}
          />
        </div>
      </form>
    </>

  )
}

CancellationInfoForm = reduxForm({
  form: 'CancellationInfoForm',
  validate
})(CancellationInfoForm);
export default withStyles(bt)(CancellationInfoForm)